import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DraftShareContext } from '../../../contexts/DraftShareContext'
import { toastError } from '../../FormComponents/Toasts'
import DraftSharePortal from './DraftSharePortal'

export default observer(function DraftShareEntry() {
  const { state, login } = useContext(DraftShareContext)
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const submitPassword = (e) => {
    e.preventDefault()
    setSubmitting(true)
    login(password)
      .catch(({ data: { error } }) => toastError(error))
      .finally(() => setSubmitting(false))
  }

  if (state.isLoading) return null

  if (!state.isAuthenticated) {
    return (
      <div className="w-screen h-screen flex flex-col justify-center items-center gap-4">
        <p className="dark:text-white">This link is password protected. Please enter the password you were given.</p>
        <form onSubmit={submitPassword} className="flex gap-2">
          <input
            type="password"
            autoFocus
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
            className="p-2 border-1 border-rb-lite-grey rounded-lg focus:ring-transparent focus:border-rb-green dark:bg-rb-dark-mode dark:text-white dark:border-rb-dark-mode-lighter"
          />
          <button disabled={submitting} type="submit" className="px-4 py-2 text-white bg-rb-green rounded-lg disabled:opacity-50">
            Submit
          </button>
        </form>
      </div>
    )
  }

  return <DraftSharePortal />
})
